import { render } from "./VolumeDefaultIcon.vue?vue&type=template&id=06b8081c"
import script from "./VolumeDefaultIcon.vue?vue&type=script&lang=js"
export * from "./VolumeDefaultIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__